// extracted by mini-css-extract-plugin
export default {"confirmation":"Confirmation_confirmation__3kwHW","buttonGrid":"Confirmation_buttonGrid__+3cGh"};